import { InputAdornment, MenuItem, TextField } from '@mui/material';
import React from 'react';

const whiteFieldSx = { '& .MuiOutlinedInput-root': { backgroundColor: 'white' } };

export interface FundDetailTextFieldProps {
  label: string;
  name: string;
  value: string | number;
  onChange: (value: string | number) => void;
  error?: string;
  type?: string;
  number?: boolean;
  readOnly?: boolean;
  startAdornment?: string;
  endAdornment?: string;
}

export const FundDetailTextField: React.FC<FundDetailTextFieldProps> = ({
  label,
  name,
  value,
  onChange,
  error,
  type,
  number,
  readOnly,
  startAdornment,
  endAdornment,
}) => (
  <TextField
    label={label}
    name={name}
    type={type || (number ? 'number' : 'text')}
    value={value ?? ''}
    onChange={(e) => onChange(number ? Number(e.target.value) : e.target.value)}
    error={!!error}
    helperText={error}
    size="small"
    fullWidth
    variant="outlined"
    InputProps={{
      readOnly,
      startAdornment: startAdornment ? (
        <InputAdornment position="start">{startAdornment}</InputAdornment>
      ) : undefined,
      endAdornment: endAdornment ? (
        <InputAdornment position="end">{endAdornment}</InputAdornment>
      ) : undefined,
    }}
    sx={whiteFieldSx}
  />
);

export interface FundDetailSelectOption {
  value: string;
  label: string;
}

export interface FundDetailSelectFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: FundDetailSelectOption[];
}

export const FundDetailSelectField: React.FC<FundDetailSelectFieldProps> = ({
  label,
  value,
  onChange,
  options,
}) => (
  <TextField
    select
    label={label}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    size="small"
    fullWidth
    variant="outlined"
    sx={whiteFieldSx}
  >
    <MenuItem value="">Not set</MenuItem>
    {options.map((opt) => (
      <MenuItem key={opt.value} value={opt.value}>
        {opt.label}
      </MenuItem>
    ))}
  </TextField>
);
